import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/news';
import { NewsCard } from '@/components/base/NewsCard';

export default function HotTopicsSection() {
  const hotNews = newsArticles.slice(0, 4);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <span className="inline-block text-xs font-label text-primary-400 border border-primary-500/40 rounded-full px-3 py-1 mb-4 whitespace-nowrap">
              实时热点
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
              突发热点
              <br />
              全网追踪
            </h2>
          </div>
          <Link
            to="/category/wanghong-tafang"
            className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotNews.map((news) => (
            <NewsCard
              key={news.id}
              id={news.id}
              title={news.title}
              excerpt={news.excerpt}
              imageUrl={news.imageUrl}
              author={news.author}
              publishDate={news.publishDate}
              readCount={news.readCount}
              tags={news.tags}
              variant="vertical"
              size="large"
            />
          ))}
        </div>
      </div>
    </section>
  );
}